'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dDashboard$002dView$0024$0024anon$002420 from "./presto.-Dashboard-View$$anon$20.js";
import * as $j_presto$002etypes$0024$002dDashboard$002dUser$002dStats$0024 from "./presto.types$-Dashboard-User-Stats$.js";
import * as $j_presto$002etypes$0024$002dEmail$0024 from "./presto.types$-Email$.js";
import * as $j_presto$002etypes$0024$002dUser$002dId$0024 from "./presto.types$-User-Id$.js";
var $p;
/** @constructor */
function $c_Lpresto_DashboardView$$anon$19() {
  this.aKb = null;
  this.aK3 = null;
  this.aK4 = false;
  this.aKc = null;
  this.aKd = false;
  this.aKg = null;
  this.aK9 = null;
  this.aKa = false;
  this.aK5 = null;
  this.aK6 = false;
  this.aK7 = null;
  this.aK8 = false;
  this.aKe = false;
  this.aKf = false;
  this.aKb = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.aKg = "DashboardUserStats";
}
export { $c_Lpresto_DashboardView$$anon$19 as $c_Lpresto_DashboardView$$anon$19 };
$p = $c_Lpresto_DashboardView$$anon$19.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_DashboardView$$anon$19;
/** @constructor */
function $h_Lpresto_DashboardView$$anon$19() {
}
export { $h_Lpresto_DashboardView$$anon$19 as $h_Lpresto_DashboardView$$anon$19 };
$h_Lpresto_DashboardView$$anon$19.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.J = (function() {
  return this.aKb;
});
$p.L = (function() {
  if ((!this.aK4)) {
    this.aK3 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.aK4 = true;
  }
  return this.aK3;
});
$p.O = (function() {
  if ((!this.aKd)) {
    this.aKc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.aKd = true;
  }
  return this.aKc;
});
$p.E = (function() {
  return this.aKg;
});
$p.t = (function() {
  if ((!this.aKa)) {
    this.aK9 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("user", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("email", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("total", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.aKa = true;
  }
  return this.aK9;
});
$p.M = (function() {
  if ((!this.aK6)) {
    this.aK5 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dUser$002dId$0024.$m_Lpresto_types$UserId$().jU(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dEmail$0024.$m_Lpresto_types$Email$().cG(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().bB, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.aK6 = true;
  }
  return this.aK5;
});
$p.Q = (function() {
  if ((!this.aK8)) {
    this.aK7 = new $j_presto$002e$002dDashboard$002dView$0024$0024anon$002420.$c_Lpresto_DashboardView$$anon$20();
    this.aK8 = true;
  }
  return this.aK7;
});
$p.w = (function() {
  if ((!this.aKf)) {
    this.aKe = false;
    this.aKf = true;
  }
  return this.aKe;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee95) => ((p) => \u03b4scrutinee95.cGz(p)))($j_presto$002etypes$0024$002dDashboard$002dUser$002dStats$0024.$m_Lpresto_types$DashboardUserStats$())));
});
var $d_Lpresto_DashboardView$$anon$19 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_DashboardView$$anon$19, "presto.DashboardView$$anon$19", ({
  GL: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_DashboardView$$anon$19 as $d_Lpresto_DashboardView$$anon$19 };
//# sourceMappingURL=presto.-Dashboard-View$$anon$19.js.map
